import * as React from 'react';
import { RangeCalendar } from '../../components/RangeCalendar';
import { FilterDepartureDates } from '../../components/FilterDepartureDates';
import { Outside } from '@cian/ui-kit';
import { IDateRange } from '../../types/dateRange';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch } from '../../types/redux';
import { changeDepartureDates } from '../../actions/filters';
import { selectDepartureDates } from '../../selectors/filters/departureDates';
import { getDateRangeText } from './utils/getDateRangeText';
import { getCalendarMaxDate } from './utils/getCalendarMaxDate';
import { useToggleState } from '../../hooks';
import { trackDepartureDatesClick } from './tracking';

export const FilterDepartureDatesContainer = () => {
  const dateRange = useSelector(selectDepartureDates);
  const dispatch = useDispatch<TDispatch>();

  const [calendarOpen, toggleCalendar] = useToggleState();

  const minDate = React.useMemo(() => new Date(), []);
  const maxDate = React.useMemo(() => getCalendarMaxDate(minDate), [minDate]);
  const dateRangeText = React.useMemo(() => getDateRangeText(dateRange), [dateRange]);

  const empty = !dateRange.from && !dateRange.to;

  const handleDateRangeChange = React.useCallback(
    (dateRange: IDateRange) => {
      dispatch(changeDepartureDates(dateRange));

      if (dateRange.from && dateRange.to) {
        toggleCalendar();
      }
    },
    [dispatch, toggleCalendar],
  );

  const handleFilterClick = React.useCallback(() => {
    toggleCalendar();

    if (!calendarOpen) {
      trackDepartureDatesClick();
    }
  }, [toggleCalendar, calendarOpen]);

  return (
    <Outside active={calendarOpen} onOutside={toggleCalendar}>
      <FilterDepartureDates
        filterText={dateRangeText}
        active={calendarOpen}
        empty={empty}
        onFilterClick={handleFilterClick}
      >
        <RangeCalendar
          open={calendarOpen}
          value={dateRange}
          minDate={minDate}
          maxDate={maxDate}
          onChange={handleDateRangeChange}
        />
      </FilterDepartureDates>
    </Outside>
  );
};
